module.exports = __webpack_public_path__ + "static/img/can-peachmango-bublyburst.a2bc46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-peachmango-bublyburst.png
// module id = 7b5Q
// module chunks = 0